// Admin panelden (ayrı origin, admin.isbulsun.com) aday olarak giriş yapmak için
// candidate JWT'sini yeni sekmeye taşır. localStorage origin'ler arası paylaşılmadığı
// için veri URL hash fragment'ında gider, hash sunucuya hiç gönderilmez (Referer'a da
// düşmez), bu yüzden query string yerine bilinçli olarak hash tercih edildi.
export function encodeImpersonationPayload(data) {
  const json = JSON.stringify(data);
  const bytes = new TextEncoder().encode(json);
  let binary = '';
  bytes.forEach((b) => {
    binary += String.fromCharCode(b);
  });
  return encodeURIComponent(btoa(binary));
}

export function decodeImpersonationPayload(hash) {
  const binary = atob(decodeURIComponent(hash));
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
  const json = new TextDecoder().decode(bytes);
  return JSON.parse(json);
}
